import {Component, OnDestroy, OnInit} from '@angular/core';
import * as dayjs from 'dayjs';
import {Subscription} from 'rxjs';
import {CalendarItem} from '../../types/calendar-item';
import {BookingV2CalendarService} from '../../services/booking-v2-calendar.service';
import {BookingV2StateService} from '../../services/booking-v2-state.service';
import {BookingV2DataService} from '../../services/booking-v2-data.service';
import {AlertStateEnum} from '../../enums/booking-enums';
import {BookingV2ManagerService} from '../../services/booking-v2-manager.service';
import {filter} from 'rxjs/operators';

interface WeekForDisplay extends CalendarItem {
  dayname: string;
  day: string;
}

@Component({
  selector: 'app-date-picker-v2',
  templateUrl: './date-picker-v2.component.html',
  styleUrls: ['./date-picker-v2.component.scss'],
})
export class DatePickerV2Component implements OnInit, OnDestroy {
  public weekData: Array<WeekForDisplay>;
  public isAlertVisible: boolean = false;
  public isExternalBlockingAlertVisible: boolean = false;
  private subscriptions: Subscription[] = [];
  private hasWeekAnyTimes: boolean = false;
  private alertState: number;

  constructor(
    private calendar: BookingV2CalendarService,
    private bookingState: BookingV2StateService,
    private bookingData: BookingV2DataService,
    private bookingManager: BookingV2ManagerService
  ) {
    dayjs.locale('sv');
  }

  ngOnInit(): void {
    this.setListeners();
  }

  ngOnDestroy() {
    this.subscriptions.forEach((sub: Subscription) => sub.unsubscribe());
  }

  public selectTime(day: string, time: string): void {
    this.bookingManager.selectTimeslot(day, time);
  }

  public isToday(d: WeekForDisplay): boolean {
    return this.calendar.isToday(d.date);
  }

  private mapCalendarResponse(response: Array<CalendarItem>): void {
    const tmp = [];
    let hasTimes = false;
    response.forEach((r, i) => {
      const d = {} as WeekForDisplay;
      const day = dayjs(r.date);
      d.dayname = this.calendar.isToday(r.date) ? 'Idag' : day.format('ddd');
      d.day = day.format('DD');
      d.times = r.times;
      d.date = r.date;
      tmp.push(d);
      if (d.times.length > 0) {
        hasTimes = true;
      }
    });
    this.hasWeekAnyTimes = hasTimes;
    this.weekData = tmp;
    this.updateIsAlertVisible();
  }

  private processAlertsState(state: number): void {
    this.alertState = state;
    this.isExternalBlockingAlertVisible =
      state !== AlertStateEnum.NORMAL &&
      state !== AlertStateEnum.NO_TIMESLOTS_REDIRECTED &&
      state !== AlertStateEnum.NO_TIMESLOTS_NO_MATCH;
    this.updateIsAlertVisible();
  }

  private updateIsAlertVisible(): void {
    this.isAlertVisible =
      this.alertState === AlertStateEnum.NORMAL &&
      this.hasWeekAnyTimes === false;
  }

  private setListeners(): void {
    this.subscriptions.push(
      this.bookingState.state$.subscribe((result) =>
        this.processAlertsState(result.alert)
      ),
      this.bookingData.calendar$
        .pipe(filter((res) => res !== null))
        .subscribe((result) => this.mapCalendarResponse(result.items))
    );
  }
}
